<template lang="pug">
  div
    b-row
      .col-xl-12
        template(v-if="$store.getters.language == 'zh'")
          cnContent
        template(v-else)
          enContent
</template>

<script>

import enContent from "@/views/account/_gameRules_en";
import cnContent from "@/views/account/_gameRules_cn";

export default {
  components: {
    enContent,
    cnContent
  }
}
</script>